import React from 'react';
import PropTypes from 'prop-types';
import Validation from '../../Validation/Validation';
import DatePicker from '../../DatePicker/DatePicker';

const DateInputFieldWithValidation = ({
  formProps,
  labelKey,
  name,
  value,
  handleChange,
  minDate,
  maxDate,
  invalidDateMessage,
  required,
  disabled,
  autoComplete,
}) => {
  const { errors, clearError } = formProps;

  return (
    <Validation name={name} errors={errors} clearError={clearError}>
      <DatePicker
        disabled={disabled}
        onDateChange={handleChange}
        autoComplete={autoComplete}
        date={value}
        invalidDateMessage={invalidDateMessage}
        labelKey={labelKey}
        name={name}
        required={required}
        minDate={minDate}
        maxDate={maxDate}
      />
    </Validation>
  );
};

DateInputFieldWithValidation.propTypes = {
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
  }).isRequired,
  labelKey: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  handleChange: PropTypes.func,
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  invalidDateMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  autoComplete: PropTypes.string,
};

DateInputFieldWithValidation.defaultProps = {
  value: null,
  handleChange: () => { },
  minDate: null,
  maxDate: null,
  invalidDateMessage: '',
  required: false,
  labelKey: '',
  disabled: false,
  autoComplete: 'on',
};

export default DateInputFieldWithValidation;
